import get from 'lodash/get';
import toLower from 'lodash/toLower';

import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { changeLocaleLanguage } from '@savgroup-front-common/core/domains/i18n/actions';
import { intl } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';

function loginSignedIn({ payload, setLoginStore }) {
  return (dispatch) => {
    const preferedLanguage =
      get(payload, ['preference', 'language']) || intl?.locale;

    if (preferedLanguage) {
      dispatch(changeLocaleLanguage({ locale: toLower(preferedLanguage) }));
    }
    setLoginStore({
      isLoaded: true,
      ...payload,
      failure: payload.failure,
      errors: payload.errors,
    });
  };
}

export function signIn({ setLoginStore } = {}) {
  return (dispatch) => {
    return apiCall(`${APIConfiguration.owner}owners/me`, {
      method: SUPPORTED_METHODS.GET,
    }).then((result) => {
      dispatch(
        loginSignedIn({
          payload: {
            isLoaded: true,
            ...result.value,
            failure: result.failure,
            errors: result.errors,
          },
          setLoginStore,
        }),
      );
    });
  };
}
